import React from "react";
import YorLoanDetails from '../AddBankDetails/yourLoanDetails';
import DepositMyLoan from "./depositMyLoan";
import { getOfferPreFilledData } from "../../selectors";
import { connect } from "react-redux";
import AddBankAccount from "./addBankAccount";
import { validateRoutingNumber, addExternalBankAccount, switchTabs } from "../../actions/crossSellApplicationActions";

export class BankDetails extends React.Component {
  constructor(props) {
    super(props);
    this.handleRepeatPaymentSelection = this.handleRepeatPaymentSelection.bind(this);
  }
    state = {
      switchTab: false,
      accountType: null,
      displayLoanDetails: true
    };
    toggleComponent = (accountType) => {
      this.setState({ switchTab: !this.state.switchTab, accountType: accountType });
    }
    handleRepeatPaymentSelection = (isRepeatPayment) => {
      this.setState({ displayLoanDetails: !isRepeatPayment });
    }
    handleExpandCollapseLoanDetailsSelection = (isExpand) => {
      this.setState( { displayLoanDetails: isExpand });
    }
    render = () => {
      let tab = <AddBankAccount accountType={this.state.accountType} switchTabs={this.props.switchTabs} switchTab={this.toggleComponent} addExternalBankAccount={this.props.addExternalBankAccount}/>;
      if (!this.state.switchTab) {
        tab = (<DepositMyLoan {...this.props} applicantDetails={this.props.offerPreFilled}
          externalAccountDetails={this.props.offerPreFilled.externalAccountDetails}
          switchTab={this.toggleComponent} handleRepeatPaymentSelection={this.handleRepeatPaymentSelection}/>);
      }
      return (
        <div className="row">
          <div className="col-lg-5 col-sm-12 col-xs-12 col-md-6 display-bank-details-flex padding-l-r-5">
            <YorLoanDetails offerPreFilled={this.props.offerPreFilled} displayLoanDetails={this.state.displayLoanDetails}
              handleExpandCollapseLoanDetailsSelection={this.handleExpandCollapseLoanDetailsSelection}/>
          </div>
          <div className="col-lg-7 col-sm-12 col-xs-12 col-md-6 article-marin-top display-bank-details-grid padding-zero">
            {tab}
          </div>
        </div>
      );
    }
}

const mapStateToProps = (state) => {
  return { offerPreFilled: getOfferPreFilledData(state), bankAccountInfo: state.bankAccountInfo };
};
const mapDispatchToProps={ validateRoutingNumber: validateRoutingNumber, addExternalBankAccount: addExternalBankAccount, switchTabs: switchTabs };
export default connect(mapStateToProps, mapDispatchToProps)(BankDetails);
